<template>
  <v-container grid-list-xl>
    <v-row wrap>
      <v-col cols="12">
        <m-card-list
          title="Daftar Pengguna"
          search
          id-key
          filter
          @refresh="load"
          :items="items"
          footerLabel="Pengguna"
          @search="
            search => {
              textSearch = search;
              pencarian();
            }
          "
          :page="page"
          @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
          footer
        >
          <template v-slot:filter>
            <FilterPengguna @filter="filter" class="px-5" />
          </template>
          <template v-slot:items="{ item }">
            <v-container>
              <v-row class="mx-3" no-gutters>
                <v-col cols="3" sm="1" md="1" lg="1">
                  <v-avatar :size="45" color="secondary2">
                    <v-icon large class="secondary--text">mdi-account</v-icon>
                  </v-avatar>
                </v-col>
                <v-col cols="12" sm="12" md="10" lg="10">
                  <v-row class="mx-0">
                    <v-col class="py-0" cols="12" sm="12" md="3" lg="3">
                      <span class="caption grey--text my-0 py-0">Nama</span>
                      <h3 class="font-weight-medium my-0 py-0 primary--text">{{ pVal(item, "name") }}</h3>
                      <p class="my-0 py-0">{{ pVal(item, "email") }}</p>
                      <div v-if="item.kecamatan" class="mt-2">
                        <span class="font-weight-bold primary--text">
                          {{ pVal(item.kecamatan.kota.propinsi, "keterangan") }} </span
                        >,
                        <span class="teal--text">{{ pVal(item.kecamatan.kota, "keterangan") }}</span>
                        <p class="orange--text">Kec. {{ pVal(item.kecamatan, "keterangan") }}</p>
                      </div>
                    </v-col>
                    <v-col class="py-0" cols="12" sm="12" md="2" lg="2" v-if="item.mapel">
                      <p class="caption my-0 py-0 grey--text">Bidang Studi</p>
                      <template v-if="item.mapel.length > 3">
                        <p class="my-2" v-for="pk in item.mapel.slice(0, 3)" :key="pk.id">
                          <span class="primary--text">{{ pVal(pk, "mapel_simpkb_id") }}</span>
                        </p>
                        <m-button
                          color="black"
                          text
                          x-small
                          :textButton="`+ ` + (item.mapel.length - 3) + ` lainnya`"
                          icon=""
                          action="toDetail"
                          @toDetail="detil(item)"
                        ></m-button>
                      </template>
                      <template v-else>
                        <p class="my-2" v-for="pk in item.mapel" :key="pk.id">
                          <span class="primary--text">{{ pVal(pk, "mapel_simpkb_id") }}</span>
                        </p></template
                      >
                    </v-col>
                    <v-col class="py-0" cols="12" sm="12" md="2" lg="2" v-if="item.jenjang">
                      <p class="caption my-0 py-0 grey--text">Jenjang</p>
                      <template v-if="item.jenjang.length > 3">
                        <p class="my-2" v-for="pk in item.jenjang.slice(0, 3)" :key="pk.id">
                          <span class="primary--text">{{ pVal(pk, "keterangan") }}</span>
                        </p>
                        <m-button
                          color="black"
                          text
                          x-small
                          :textButton="`+ ` + (item.jenjang.length - 3) + ` lainnya`"
                          icon=""
                          action="toDetail"
                          @toDetail="detil(item)"
                        ></m-button>
                      </template>
                      <template v-else>
                        <p class="my-2" v-for="pk in item.jenjang" :key="pk.id">
                          <span class="primary--text">{{ pVal(pk, "keterangan") }}</span>
                        </p></template
                      >
                    </v-col>
                    <v-col class="py-0" cols="12" sm="12" md="2" lg="2">
                      <p class="caption my-0 py-0 grey--text">Peran</p>
                      <p small outlined v-for="pkb in item.grup" :key="pkb.id" class="justify-center ma-0 mt-2">
                        {{ pVal(pkb, "keterangan") }}
                      </p>
                    </v-col>
                    <v-col class="py-0" cols="12" sm="12" md="3" lg="3">
                      <p class=" mb-0 py-0 grey--text caption">Peran Kelas</p>
                      <m-more :items="item.perankelas"></m-more>
                      <!-- <p
                        small
                        outlined
                        v-for="pk in item.perankelas"
                        :key="pk.id"
                        class="caption justify-center ma-0 mt-2"
                      >
                        {{ pVal(pk.grup, "keterangan") }} - Kelas {{ pVal(pk.kelas, "nama") }}
                      </p>  -->
                    </v-col>
                  </v-row>
                </v-col>
                <v-col lg="1" md="1" sm="1" cols="1">
                  <m-menu right class="clearfix" style="float:right" :items="more_menu" :object="item" />
                </v-col>
              </v-row>
            </v-container>
          </template>
        </m-card-list>
      </v-col>
      <DetailDlg ref="dlg" />
    </v-row>
  </v-container>
</template>

<script>
import { ALERT_INFO } from "@/const";
import DetailDlg from "../../user/components/Detil.vue";
import FilterPengguna from "@/filter/FilterPengguna.vue";
import MMore from "../../../components/MMore.vue";

export default {
  components: {
    DetailDlg,
    FilterPengguna,
    MMore
  },
  data() {
    return {
      alert: ALERT_INFO,
      items: [],
      itemMapels: [],
      peran: null,
      perankelas: null,
      mapel: null,
      jenjang: null,
      textSearch: null,
      page: null,
      cp: 1,
      more_menu: [
        // eslint-disable-next-line
        {
          title: "Detil Pengguna",
          click: (i, o) => this.detil(o)
        }
      ]
    };
  },
  computed: {
    headers() {
      const a = [{ text: "", align: "left", value: "" }, { text: "", sortable: false }, { text: "", sortable: false }];
      return a;
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      if (this.instansi_id && this.$route.params.diklat_id) {
        return this.$store
          .dispatch("user/getPenggunaDiklat", {
            instansi_id: this.instansi_id,
            diklat_id: this.$route.params.diklat_id,
            params: {
              page: this.cp,
              s: this.textSearch,
              grup_simpkb_id: this.peran,
              grup_id: this.perankelas,
              mapel_id: this.mapel,
              jenjang_id: this.jenjang
            }
          })
          .then(res => {
            this.page = res;
            this.items = res.data;
          })
          .catch(e => e);
      }
    },
    pencarian() {
      this.cp = 1;
      this.current_page = 1;
      this.load();
    },
    filter(data) {
      this.current_page = 1;
      this.peran = null;
      this.perankelas = null;
      this.jenjang = null;
      if (data.peran && data.peran.length > 0) {
        this.peran = data.peran;
      }
      if (data.perankelas && data.perankelas.length > 0) {
        this.perankelas = data.perankelas;
      }
      if (data.mapel && data.mapel.length > 0) {
        this.mapel = data.mapel;
      }
      if (data.jenjang && data.jenjang.length > 0) {
        this.jenjang = data.jenjang;
      }
      this.load();
    },
    ajukan(item) {
      this.$confirm(
        `Apakah Anda yakin akan mempublikasikan Anggota ini ?<br>
        <div class="mt-2 title grow text-center">
           ${item.judul} <br>
        </div>
      `
      )
        .then(() =>
          this.$store
            .dispatch("user/ajukan", { obj: item })
            .then(() => {
              this.$info("Data berhasil diajukan");
            })
            .then(() => this.load())
            .catch(e => e)
        )
        .catch(e => e);
    },
    detil(item) {
      this.$refs.dlg.open(item).then(() => {});
    },
    hapus(item) {
      this.$confirm(
        `Apakah Anda yakin akan menghapus user ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.name}<br>
        </div>`,
        {
          cancelOnly: item.laporan_accepted_count > 0 ? true : false
        }
      )
        .then(() => this.$store.dispatch("user/drop", item))
        .then(() => {
          this.$info("User " + item.name + " berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    }
  },
  watch: {
    instansi_id() {
      if (this.instansi_id) {
        this.cp = 1;
        this.load();
      }
    },
    diklat_id() {
      if (this.diklat_id) {
        this.cp = 1;
        this.load();
      }
    }
  }
};
</script>
